import { render, staticRenderFns } from "./text-row-supplier-accounting.vue?vue&type=template&id=38472494&"
import script from "./text-row-supplier-accounting.vue?vue&type=script&lang=js&"
export * from "./text-row-supplier-accounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38472494')) {
      api.createRecord('38472494', component.options)
    } else {
      api.reload('38472494', component.options)
    }
    module.hot.accept("./text-row-supplier-accounting.vue?vue&type=template&id=38472494&", function () {
      api.rerender('38472494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-supplier-accounting.vue"
export default component.exports